import React from 'react'
import { Link } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
import { Accordion } from 'react-bootstrap'
import RwIcon from '../RwIcon'

interface LinkItem {
  id?: string
  link_to: string
  title: string
  icon?: string
}

interface ProLineNavSectionMobileProps {
  title: string
  data?: LinkItem[]
  queryType?: string
  isDarkMode: boolean
  onClickQuickLink: (e: any) => void
  useQueryParams?: boolean
  component?: React.ReactNode
}

const ProLineNavSectionMobile: React.FC<ProLineNavSectionMobileProps> = ({
  title,
  data,
  isDarkMode,
  onClickQuickLink,
  component,
}) => {
  return (
    <Accordion
      flush
      className={`hamburger-menu ${isDarkMode ? 'dm-accordion-primary' : ''}`}
    >
      <div className="border-bottom">
        <Accordion.Item eventKey={title} className="border-0">
          <Accordion.Header>
            <div className="fw-bold fs-5">{title}</div>
          </Accordion.Header>
          <Accordion.Body>
            {component ? (
              component
            ) : (
              <Nav className="flex-column">
                {data?.map((item, index) => {
                  return (
                    <Nav.Link
                      key={`${item.id ?? item.link_to}-${index}`}
                      className={`ms-2 ${
                        index !== 0 ? 'border-top border-1' : ''
                      } ${isDarkMode ? 'text-light' : 'text-primary'}`}
                      as={Link}
                      to={item.link_to}
                      id={item.link_to}
                      onClick={onClickQuickLink}
                      data-bs-value={item.link_to}
                    >
                      {item.title}{' '}
                      {item.icon && (
                        <RwIcon
                          icon={`${item.icon}${isDarkMode ? 'Dm' : ''}`}
                        />
                      )}
                    </Nav.Link>
                  )
                })}
              </Nav>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </div>
    </Accordion>
  )
}

export default ProLineNavSectionMobile
